import InternalDatabase from "./internal-database"
import Task from "../task/task"
import {INTERNAL_DB_CHANGED} from "./@const"
import {DeltaEventMethodType} from "../../gd/manager/delta-handler/types";

// in views ... resource loading ... gd.loadDB(id)
// gd.loadDBs([id])

//
//

//

// const debug = "Databases"
const debug = false

export default class Databases {


    public internalDatabases : { [key: string]: InternalDatabase }        = {}

    constructor() {
        // subscribe to task session events
        gd.modelBus.subscribe("task", this, this.onSessionTaskChange)
    }

    onSessionTaskChange = (method: string, data: any, header: any) => {
        // check if task project id is one of internalDatabases
        const internalDB = this.internalDatabases[header.task.projectId]
        if (!internalDB) return // skip task session event if db not found

        switch (method) {
            case DeltaEventMethodType.NEW:
                internalDB.tasks?.add(new Task(data))
                break

            case DeltaEventMethodType.DELETE:
                internalDB.tasks?.remove(header.task.id)
                break

            case DeltaEventMethodType.DELTA:
                const task = internalDB.tasks?.get(header.task.id)
                task?.applyDelta(data)
                break
        }

        // trigger bus event to notify internal DB has changed
        gd.bus.triggerEvent(INTERNAL_DB_CHANGED, {
            internalDB  : internalDB,
            taskId      : header.task.id
        })
    }

    // return all internal DB projects (is used in parent selector)
    get projects() {
        return _.map(this.internalDatabases, (internalDatabase: InternalDatabase) => {
            return internalDatabase.project
        })
    }

    getInternalDB(projectId:ID) : InternalDatabase | undefined {

        debug && console.log(debug, "getInternalDB id=", projectId);

        if (this.internalDatabases[projectId]) {
            return this.internalDatabases[projectId]
        }

        debug && console.log(debug, "    not found");

        return undefined
    }

    addInternalDB(internalDB: InternalDatabase) : void {
        this.internalDatabases[internalDB.id] = internalDB
    }

    deleteInternalDBByProjectId(projectId: ID) : void {
        delete this.internalDatabases[projectId]
    }

    /*static initFromJson(data: any): InternalDatabaseCollection {
        const models: InternalDatabase[] = []

        _.map(data, (record: JSONObject) => {
            const internalDb = new InternalDatabase(record)

            models.push(internalDb)
        })

        const collection = new InternalDatabaseCollection()
        collection.reset(models)

        return collection
    }*/


}
